import { render } from "./humanityCourseInfo.vue?vue&type=template&id=73fb2c5e&scoped=true"
import script from "./humanityCourseInfo.vue?vue&type=script&lang=js"
export * from "./humanityCourseInfo.vue?vue&type=script&lang=js"

import "./humanityCourseInfo.vue?vue&type=style&index=0&id=73fb2c5e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fb2c5e"]])

export default __exports__